import store from '@/store';
import i18n from '@/i18n';

export default function getRequestHeader(
  token?: string
): {
  'X-Ekyc-Request-Token': string;
  'X-Ekyc-Current-Language': string;
} {
  return {
    'X-Ekyc-Request-Token': `${token || store.getters['auth/requestToken']}`,
    'X-Ekyc-Current-Language': i18n.locale
  };
}
